import { render, staticRenderFns } from "./pavingTrace.vue?vue&type=template&id=642d0924&scoped=true&"
import script from "./pavingTrace.vue?vue&type=script&lang=js&"
export * from "./pavingTrace.vue?vue&type=script&lang=js&"
import style0 from "./pavingTrace.vue?vue&type=style&index=0&id=642d0924&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "642d0924",
  null
  
)

export default component.exports